import { render, staticRenderFns } from "./StudentBeRepeated.vue?vue&type=template&id=5374cae4&"
import script from "./StudentBeRepeated.vue?vue&type=script&lang=js&"
export * from "./StudentBeRepeated.vue?vue&type=script&lang=js&"
import style0 from "./StudentBeRepeated.vue?vue&type=style&index=0&id=5374cae4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports